// extracted by mini-css-extract-plugin
export default {"date-container":"emjXu","dateContainer":"emjXu"};